import React, { memo } from 'react';
import { Table } from '../../../../Table';
import { buildTransactionsTableData } from './utils';


var InvestmentTransactionsTable = function (_a) {
    var _b = _a.investment, transactions = _b.transactions, currencyCode = _b.currencyCode;
    var _c = buildTransactionsTableData(transactions, currencyCode), headers = _c.headers, rowsData = _c.rowsData;
    return React.createElement(Table, { headers: headers, rows: rowsData });
};
export default memo(InvestmentTransactionsTable);
